<template>
  <div class="">
    <div class="box-header title-boreder">
      <h3 class="box-title title"> Seguimiento de documento</h3>
    </div>
    <div class="box box-success">
      <div class="box-header title-boreder">
        <h3 class="box-title box-title-sub">
          <img class="icon-space" src="/static/img/icons/search.png" style="padding-bottom:7px">Buscar Documento
        </h3>
        <div class="box-tools pull-right">
          <button v-on:click="advancedSearch()" class="btn btn-link btn-lg"><i class="fa fa-filter"></i>&nbsp;&nbsp;Avanzado</button>
        </div>
      </div>
      <div class="box-body">
        <div class="filterContainer">
          <div class="row">
            <div class="col-md-2">
              <div id="divAccount" class="form-group">
                <label>Cuenta</label>  
                <multiselect
                  :value="this.selectedAccount"
                  selectLabel=""
                  selectedLabel=""
                  deselectLabel=""
                  track-by="name"
                  :placeholder="this.selectedAccount.name"
                  :allow-empty="false"
                  label="name"
                  :options="this.optionsAccount"
                  @input="onAccountSelect">
                  <span slot="noResult">
                    No se encontraron resultados
                  </span>
                </multiselect>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Tipo de Documento</label>
                <select id="ddlDocumentType" v-model="documentType" @change="onDocumentSelect" class="form-control minimal">
                  <option v-for="type in this.optionDocumentType" v-bind:key="type.code" v-bind:value="type.code">
                    {{ type.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <label for="dtDateRange">Desde - Hasta</label>
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-addon">
                      <i class="icon-calendar"></i>
                    </div>
                    <input id="dtDateRange" mode="text" class="form-control">
                  </div>
                </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Tipo Pedido</label>
                <select id="ddlTypeOrder" v-model="typeOrder" class="form-control minimal">
                  <option v-for="type in this.optionTypeOrder" v-bind:key="type.code" v-bind:value="type.code">
                    {{ type.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Nro. de Documento</label>
                <input id="documentNumber" v-model="documentNumber" class="form-control"/>
              </div>
            </div>
            <div class="col-md-2 pull-center" style="padding-top:25px;">
              <button v-on:click="search()" class="btn btn-sm btn-success btnAction btn-search"> Buscar</button>
            </div>
          </div>
          <transition name="fade">
            <div class="row" v-if="showAdvance">
              <div class="col-md-2">
                <div class="form-group">
                  <label>Nro. de Tracking</label>
                  <input id="trackingNumber" v-model="trackingNumber" class="form-control"/>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Referencia de Pedido</label>
                  <input id="referenceOrder" v-model="referenceOrder" class="form-control"/>
                </div>
              </div>
              <div class="col-md-4">
                <div id="divClientSelect" class="form-group">
                  <label>Cliente/Proveedor</label>
                  <multiselect
                    :value="this.selectedClient"
                    selectLabel=""
                    selectedLabel=""
                    deselectLabel=""
                    track-by="code"
                    :placeholder="this.selectedClient.text"
                    :allow-empty="false"
                    label="text"
                    :options="this.optionsClient"
                    @input="onClientSelect">
                    <span slot="noResult">
                      No se encontraron resultados
                    </span>
                  </multiselect>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="box box-success">
      <div class="box-header title-boreder">
        <h3 class="box-title box-title-sub">
          <img src="/static/img/icons/result.png" class="icon-space" style="padding-bottom:3px;">
          <span>BUSCAR DOCUMENTO</span></h3>
      </div>
      <div class="box-body">
        <div id="resultTable">
          <vuetable 
            id="resultTable"
            ref="vuetable"
            :api-mode="false"
            :fields="tableFields"
            :css="tableCSS.table"
            noDataTemplate="No se encontraron resultados"
            :data="tableData"
            :data-manager="dataManager"
            pagination-path="pagination"
            @vuetable:pagination-data="onPaginationData"
            :key="tableKey">
            <template slot="documentTypeCode" scope="props">
              <div class="text-center" >
              <span v-if="window.width > 750" v-bind:class="documentTypeClass(props.rowData.documentTypeCode)"></span>
              </div>
            </template>
            <template slot="documentTypeName" scope="props">
              <div id="TIPO">
                <span >{{props.rowData.documentTypeName}}</span>
              </div>
            </template>
            <template slot="documentNumber" scope="props">
              <div id="Número">
                <span >{{props.rowData.documentNumber}}</span>
              </div>
            </template>
            <template slot="documentDate" scope="props">
              <div id="Fecha">
                <span >{{props.rowData.documentDate | formatDate("DD/MM/YYYY",true)}}</span>
              </div>
            </template>
            <template slot="referenceOrder" scope="props">
              <div id="NumeroReferencia">
                <span >{{props.rowData.referenceDocumentNumber1}}</span>
              </div>
            </template>
            <template slot="trackingNumber" scope="props">
              <div id="NumeroTracking">
                <span >{{props.rowData.trackingNumber}}</span>
              </div>
            </template>
            <template slot="quantitiesDocument" scope="props">
              <div id="Cantidades" align="center">
                <span >{{props.rowData.quantityComplete}} / {{props.rowData.quantityTotal}}<span style="font-size:12px"> {{props.rowData.minimumStockUnit}}</span></span>
              </div>
            </template>
            <template slot="supplierCustomerDescription" scope="props">
              <div id="Cliente">
                <span >{{props.rowData.supplierCustomerDescription}}</span>
              </div>
            </template>
            <template slot="progress" scope="props">
              <div class="progressContainer text-center">
                <div>
                  <strong class="progressInfo" >{{props.rowData.status}} ({{props.rowData.progress}}%)</strong>
                  <!-- <strong class="progressInfo-persentage" style="padding-left:150px;">{{props.rowData.f}}%</strong> -->
                </div>
                <div class="progressBar">
                  <div class="progress table-bar-document" v-if="props.rowData.progress">
                    <div :class="'progress-bar progress-bar-' + formatProgress(props.rowData.progress)" role="progressbar" :aria-valuenow="props.rowData.progress"
                      aria-valuemin="0" aria-valuemax="100" :style="'width:' + props.rowData.progress + '%'">
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template slot="referenceOrder" scope="props">
              <div id="NumeroReferencia">
                <span >{{props.rowData.referenceDocumentNumber1}}</span>
              </div>
            </template>
            <template slot="trackingNumber" scope="props">
              <div id="NumeroTracking">
                <span >{{props.rowData.trackingNumber}}</span>
              </div>
            </template>
            <template slot="tracking" scope="props">
              <div v-if="props.rowData.documentNumber" class="text-center botonVerDetalle2">
                <router-link  v-if="window.width > 750" :to="{name: 'DocumentMonitoring',
                  params: {selectedAccount: selectedAccount, documentNumber: props.rowData.documentNumber, documentType: props.rowData.documentTypeCode, minimumStockUnit: props.rowData.minimumStockUnit, address1: props.rowData.address1, trackingNumber: props.rowData.trackingNumber, referenceDocumentNumber1: props.rowData.referenceDocumentNumber1, codeOrderType: props.rowData.codeOrderType, orderType: props.rowData.orderType, showAdvanceMain: showAdvance} }"
                  tag="button" class="btn table-btn">
                  <span class="table-btn-icon"></span>
                </router-link>
                <router-link v-if="window.width < 750" :to="{name: 'DocumentMonitoring',
                  params: {selectedAccount: selectedAccount, documentNumber: props.rowData.documentNumber, documentType: props.rowData.documentTypeCode, minimumStockUnit: props.rowData.minimumStockUnit, address1: props.rowData.address1, trackingNumber: props.rowData.trackingNumber, referenceDocumentNumber1: props.rowData.referenceDocumentNumber1, codeOrderType: props.rowData.codeOrderType, orderType: props.rowData.orderType, showAdvanceMain: showAdvance} }"
                  tag="button" class="btn table-btn">
                  <span style=" color:#364A5D; font-size:14px;font-weight: bold;">Ver detalles</span>
                </router-link>
              </div>
            </template>
          </vuetable>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        &nbsp;
        <template v-if="this.paginationData && paginationData.total > 0">
          <strong style="color: #364A5D; paddin-left:15px;">
          Mostrando documento {{ this.paginationData.from > 1 ? this.paginationData.from : this.paginationData.from + (pageNumber-1)*10 }} a {{ this.paginationData.to * this.pageNumber }} de {{ this.paginationData.total }} en Total
          </strong>
        </template>
      </div>
      <div class="col-md-6">
        <vuetable-pagination ref="pagination"
          :css="tableCSS.pagination"
          @vuetable-pagination:change-page="onChangePage"
        ></vuetable-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import { Vuetable, VuetablePagination } from 'vuetable-2'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'bootstrap-daterangepicker/daterangepicker.css'
import 'bootstrap-daterangepicker/daterangepicker.js'
import moment from 'moment/moment.js'
import constants from 'assets/js/constants.js'

export default {
  name: 'DocumentSearch',
  data () {
    return {
      showAdvance: false,
      loader: null,
      loader2: null,
      loadeadBack: true,
      optionsAccount: null,
      selectedAccount: null,
      selectedClient: null,
      optionsClient: [{code: '', text: 'Todos'}],
      optionDocumentType: [],
      documentType: null,
      optionTypeOrder: [],
      typeOrder: null,
      documentNumber: '',
      trackingNumber: '',
      referenceOrder: '',
      documentStartDate: '',
      documentEndDate: '',
      tableKey: 1,
      tableData: {
        data: null
      },
      totalPages: 0,
      pageNumber: 1,
      window: {
        width: 0,
        height: 0
      },
      tableFields: [
        {
          name: '__slot:documentTypeCode',
          title: '',
          titleClass: 'table-text',
          dataClass: 'table-text'
        },
        {
          name: '__slot:documentTypeName',
          title: 'Tipo',
          titleClass: 'table-text',
          dataClass: 'table-text'
        },
        {
          name: '__slot:documentNumber',
          title: 'Número',
          titleClass: 'table-text',
          dataClass: 'table-text'
        },
        {
          name: '__slot:documentDate',
          title: 'Fecha',
          callback: 'formatDate',
          titleClass: 'table-text',
          dataClass: 'table-text'
        },
        {
          name: '__slot:quantitiesDocument',
          title: 'ATENDIDO / SOLICITADO',
          titleClass: 'table-text',
          dataClass: 'table-text'
        },
        {
          name: '__slot:supplierCustomerDescription',
          title: 'Cliente / Proveedor',
          titleClass: 'table-text',
          dataClass: 'table-text client-table'
        },
        {
          name: '__slot:progress',
          title: 'Progreso',
          titleClass: 'table-text'
        },
        {
          name: '__slot:referenceOrder',
          title: 'Nro. Referencia',
          titleClass: 'table-text',
          dataClass: 'table-text'
        },
        {
          name: '__slot:trackingNumber',
          title: 'Nro. Tracking',
          titleClass: 'table-text',
          dataClass: 'table-text'
        },
        {
          name: '__slot:tracking',
          title: '',
          titleClass: 'table-text'
        }
      ],
      tableCSS: null,
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      paginationData: null
    }
  },
  computed: {
    ...mapGetters([
      'userClients',
      'documentSearch'
    ])
  },
  created () {
    this.tableCSS = constants.tableCSS
    this.showAdvance = this.$route.params.showAdvance
    this.loadSelectData()
  },
  mounted () {
    var self = this
    $(this.$el).find('#dtDateRange').daterangepicker({
      showDropdowns: true,
      startDate: moment().format('DD/MM/YYYY'),
      endDate: moment().format('DD/MM/YYYY'),
      dateLimit: {'days': 30},
      locale: constants.datePickerLocale
    }, function (start, end, label) {
      $('#divModeButtons button.btn-success').click()
    })
    $('#dtDateRange').on('apply.daterangepicker', function (ev, picker) {
      self.getClients()
    })
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    if (this.$route.params.tracking) {
      $('#dtDateRange').data('daterangepicker').setStartDate(moment(this.documentSearch.filter.params.StartDate).format('DD/MM/YYYY'))
      $('#dtDateRange').data('daterangepicker').setEndDate(moment(this.documentSearch.filter.params.EndDate).format('DD/MM/YYYY'))
    }
    this.getClients()
  },
  methods: {
    ...mapActions([
      'searchDocument',
      'searchDocument2',
      'searchDocumentPage',
      'getDocumentTypes',
      'getSupplierCustomer',
      'getItemsForAccountConfiguration'
    ]),
    loadSelectData () {
      this.optionsAccount = Array.from(this.userClients)
      this.selectedAccount = this.optionsAccount[0]
      this.selectedClient = this.optionsClient[0]

      this.getTypes()
      this.getTypesOrders()
    },
     /* DropDownList Events */
    onAccountSelect (account) {
      this.selectedAccount = account
      this.selectedClient = this.optionsClient[0]
      this.getClients()
      this.documentType = null
      this.getTypes()
      this.typeOrder = null
      this.getTypesOrders()
      this.documentNumber = ''
      this.trackingNumber = ''
      this.referenceOrder = ''
      $('#dtDateRange').data('daterangepicker').setStartDate(moment().format('DD/MM/YYYY'))
      $('#dtDateRange').data('daterangepicker').setEndDate(moment().format('DD/MM/YYYY'))
      this.tableData = {
        data: null
      }
    },
    onClientSelect (client) {
      this.selectedClient = client
    },
    onDocumentSelect () {
      this.getClients()
    },
    getClients () {
      this.onLoading()
      if (this.showAdvance) {
        this.optionsClient = [{code: '', text: 'Todos'}]
        this.selectedClient = this.optionsClient[0]
        let params = {
          accountCode: this.selectedAccount.code,
          documentType: this.documentType ? this.documentType : '',
          startDate: $(this.$el).find('#dtDateRange').data('daterangepicker').startDate.format('YYYYMMDD'),
          endDate: $(this.$el).find('#dtDateRange').data('daterangepicker').endDate.format('YYYYMMDD')
        }
        this.getSupplierCustomer(params).then((response) => {
          this.optionsClient = [
            {code: '', text: 'Todos'},
            ...response]
          this.onLoaded()
          this.reloadData()
        })
      } else {
        this.onLoaded()
        this.reloadData()
      }
    },
    getTypes () {
      this.optionDocumentType = []
      let params = {
        params: {
          AccountCode: this.selectedAccount.code
        }
      }
      this.getDocumentTypes(params).then((response) => {
        this.optionDocumentType = [
          {code: null, text: 'Todos'},
          ...response]
      })
    },
    getTypesOrders () {
      this.optionTypeOrder = []
      let params = {
        accountCode: this.selectedAccount.code,
        typeConfigurationId: 3
      }
      this.getItemsForAccountConfiguration(params).then((response) => {
        this.optionTypeOrder = [
          {code: null, text: 'Todos'},
          ...response]
      })
    },
    reloadData () {
      if (this.$route.params.tracking) {
        this.search()
      }
    },
    search () {
      this.pageNumber = 1
      document.activeElement.blur()
      if (this.$route.params.tracking) {
        this.$route.params.tracking = false
        this.selectedAccount = this.documentSearch.filter.AccountSelect
        this.documentType = this.documentSearch.filter.params.DocumentType
        this.documentStartDate = this.documentSearch.filter.params.StartDate
        this.documentEndDate = this.documentSearch.filter.params.EndDate
        this.selectedClient = this.documentSearch.filter.ClientSelect
        this.typeOrder = this.documentSearch.filter.params.CodeOrderType
        this.documentNumber = this.documentSearch.filter.params.DocumentNumber
        this.trackingNumber = this.documentSearch.filter.params.TrackingNumber
        this.referenceOrder = this.documentSearch.filter.params.ReferenceOrder
      } else {
        this.documentStartDate = ''
        this.documentEndDate = ''
      }

      if (this.documentStartDate === '' && this.documentEndDate === '') {
        this.documentStartDate = $(this.$el).find('#dtDateRange').data('daterangepicker').startDate.format('YYYYMMDD')
        this.documentEndDate = $(this.$el).find('#dtDateRange').data('daterangepicker').endDate.format('YYYYMMDD')
      }

      if (this.documentNumber !== '' || (this.documentStartDate !== '' && this.documentEndDate !== '')) {
        this.onLoading()
        this.tableData = {
          data: null
        }

        let params = {
          AccountSelect: this.selectedAccount,
          ClientSelect: this.selectedClient,
          params: {
            AccountCode: this.selectedAccount.code,
            DocumentType: this.documentType,
            DocumentNumber: this.documentNumber.trim(),
            SupplierCustomerCode: this.selectedClient.code ? this.selectedClient.code : null,
            CodeOrderType: this.typeOrder,
            TrackingNumber: this.trackingNumber.trim(),
            ReferenceOrder: this.referenceOrder.trim(),
            StartDate: this.documentStartDate,
            EndDate: this.documentEndDate
          },
          page: {
            Page: this.pageNumber
          }
        }
        this.searchDocument2(params).then((data) => {
          if (data != null) {
            this.tableData = {
              data: data.documents
            }
            this.totalPages = {
              data: data.totalPages
            }
            this.onLoaded()
            this.tableKey++
          }
        })
      } else {
        this.$bus.$emit('modal-open', {
          title: 'Error',
          description: 'Ingrese un Tipo y Número de documento o un Rango de Fechas.',
          type: 'info',
          confirmText: 'Aceptar',
          cancelText: null,
          confirmBefore: () => {
          },
          confirmAfter: () => {
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      }
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    /* Table Events */
    onLoading () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })
    },
    onLoaded () {
      this.loader.hide()
      /* if (this.$route.params.tracking && !this.loadeadBack) {
        this.loadeadBack = true
        this.$refs.vuetable.changePage(this.documentSearch.page)
      } */
    },
    formatType (value) {
      let formattedVal = this.optionDocumentType.filter(item => item.code === value)
      return formattedVal.length > 0 ? formattedVal[0].text : ''
    },
    formatStatus (statusCode) {
      let classVal = ''

      switch (statusCode) {
        case 1:
          classVal = 'success'
          break
        default:
          classVal = 'warning'
          break
      }

      return classVal
    },
    formatDate (value) {
      return moment(value).format('DD/MM/YYYY')
    },
    formatProgress (documentProgress) {
      let classVal = ''

      if (documentProgress >= 90) {
        classVal = 'success'
      } else if (documentProgress >= 50) {
        classVal = 'warning'
      } else {
        classVal = 'danger'
      }

      return classVal
    },
    /* Table Pagination */
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.paginationData = paginationData
    },
    onChangePage (page) {
      this.loader2 = this.$loading.show({
        loader: 'dots'
      })

      this.$refs.vuetable.changePage(page)
      if (page > 0) {
        this.pageNumber = page
      }
      if (page === 'next') {
        this.pageNumber += 1
        if (this.pageNumber >= this.totalPages.data) {
          this.pageNumber -= 1
          return
        }
      }
      if (page === 'prev') {
        this.pageNumber -= 1
        if (this.pageNumber < 1) {
          this.pageNumber += 1
          return
        }
      }
      let params = {
        AccountSelect: this.selectedAccount,
        ClientSelect: this.selectedClient,
        params: {
          AccountCode: this.selectedAccount.code,
          DocumentType: this.documentType,
          DocumentNumber: this.documentNumber.trim(),
          SupplierCustomerCode: this.selectedClient.code ? this.selectedClient.code : null,
          CodeOrderType: this.typeOrder,
          TrackingNumber: this.trackingNumber.trim(),
          ReferenceOrder: this.referenceOrder.trim(),
          StartDate: this.documentStartDate,
          EndDate: this.documentEndDate
        },
        page: {
          Page: this.pageNumber
        }
      }
      this.searchDocument2(params).then((data) => {
        this.tableData = {
          data: data.documents
        }
        this.totalPages = {
          data: data.totalPages
        }
        this.loader2.hide()
        this.tableKey++
      })
    },
    dataManager (sortOrder, pagination) {
      let data = []
      data = this.tableData.data
      if (this.tableData.data && this.totalPages.data > 1) {
        pagination = this.$refs.vuetable.makePagination(data.length)
        pagination.last_page = this.totalPages.data
        pagination.current_page = this.pageNumber
        pagination.total = this.totalPages.data > 1 ? this.totalPages.data : this.totalpages.data
        pagination.next_page_url = pagination.current_page + 1
        if (pagination.next_page_url > 1) {
          pagination.prev_page_url = pagination.current_page - 1
        }
        data = data.slice(pagination.from - 1, pagination.to)
      } else {
        pagination = this.$refs.vuetable.makePagination(0)
      }
      return {
        pagination: pagination,
        data: data
      }
    },
    documentTypeClass: function (type) {
      let typeClass = ''
      switch (type) {
        case 'PE':
          typeClass += 'icon-PE '
          break
        case 'DV':
          typeClass += 'icon-DV '
          break
        case 'OC':
          typeClass += 'icon-OC '
          break
        case 'GU':
          typeClass += 'icon-GU '
          break
        case 'BL':
          typeClass += 'icon-BL '
          break
        default:
          typeClass += 'default'
          break
      }

      return typeClass
    },
    advancedSearch () {
      this.optionsClient = [{code: '', text: 'Todos'}]
      this.selectedClient = this.optionsClient[0]
      this.trackingNumber = ''
      this.referenceOrder = ''

      if (this.showAdvance) {
        this.showAdvance = false
      } else {
        this.showAdvance = true
        this.getClients()
      }
    }
  },
  components: {
    Multiselect,
    Vuetable,
    'vuetable-pagination': VuetablePagination
  }/* ,
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  } */
}
</script>

<style>

.vuetable-th-slot-documentTypeCode { 
  width: 3%; 
}

.vuetable-th-documentTypeName{ 
  width: 8%; 
}

.vuetable-th-documentNumber {
  width: 10%;
}

.vuetable-th-documentDate  {
  width: 10%;
}

.vuetable-th-referenceOrder {
  width: 18%;
}

.vuetable-th-trackingNumber {
  width: 18%;
}

.vuetable-th-quantitiesDocument {
  width: 20%;
}

.vuetable-th-slot-progress  {
  width: 12%;
}

.vuetable-th-slot-tracking  {
  width: 2%;
}

.label.type {
	background-image: url('/static/img/icons/document.png');
	font-size: 14px;
	background-size: cover;
	height: 36px;
	width: 36px;
	padding-top: 19px;
	background-color: transparent !important;
	display: block;
	background-position: 0px 0px;
	background-repeat: no-repeat;
	padding-left: 8px;
}
.type-pe {
  color: green !important
}

.type-dv {
  color: orange !important
}

.type-oc {
  color: blueviolet !important
}

.type-gu {
  color: yellow !important
}

.type-bl {
  color: blue !important
}

.progressInfo {
  z-index: 10;
  padding-top: 8%!important;
  text-align: left;
  color: #364A5D;	
  font-size: 11px;	
  font-weight:bold !important;	
  line-height: 22px !important;
}

.progressInfo-persentage{
  padding-left: 18%;
  padding-top: 7%!important;
  text-align: right;
  color: #364A5D;
	font-size: 14px;
  font-weight: 200 !important;	
  line-height: 18px !important;
}

#resultTable .progressBar,
.progressInfo {
  position: absolute !important;
}

.table-bar{
  height: 10px !important;
  width: 132px;
}

.table-bar-document{
  height: 10px !important;
  width: 132px;
}

.title-boreder{
  border-bottom: 2px solid #F2F4F6;
}

.filterContainer{
  background: none !important;
}

.btn-search{
 	height: 48px;	
  width: 101px;
}

.table-btn{
  float:right;
  background: none !important;
}

.table-btn-icon::before{
  content: url('/static/img/icons/arrow-table.png');
}

.table-text{
 vertical-align: middle !important;
}

/* .progress-bar-yellow, .progress-bar-warning{

} */

.progress-bar-green, .progress-bar-success{
    background-color:#009D00;
}

/* .progress-bar-red, .progress-bar-danger{
  
}
 */
.search-document-icon::before{
  content: url("/static/img/icons/search.png");
}

.client-table{
  text-transform: lowercase;
}

.result-searh-icon::before{
  content: url("/static/img/icons/result.png");
  vertical-align: middle;
}

.icon-calendar::before{
  content: url('/static/img/icons/calendar.png')
}

.input-group-addon{
  border-right: none;
  width: 20%;
}

.divAccountSelect{
  width: 18% !important;
}

@media screen and (max-width: 1330px) {
  .divAccountSelect{
    width: 20% !important;
  }
}

@media screen and (max-width: 1150px) {
  .divAccountSelect{
    width: 25% !important;
  }
}

@media screen and (max-width: 990px) {
  .divAccountSelect{
    width: 100% !important;
  }
}

.divDateRange{
  width: 19% !important;
}

@media screen and (max-width: 1330px) {
  .divDateRange{
    width: 21% !important;
  }
}

@media screen and (max-width: 1150px) {
  .divDateRange{
    width: 26% !important;
  }
}

@media screen and (max-width: 990px) {
  .divDateRange{
    width: 100% !important;
  }
}

@media screen and (max-width: 750px) {
  .vuetable-empty-result{
    text-align: center !important;
  }

  #documentTypeCode td{
    padding-left: 50%  !important;

  }

  .progressInfo{
    padding-top: 6% !important
  }

  .botonVerDetalle2{
    border-top: solid 3px!important;
    margin-top: 25px;
    border-color:#F2F4F6 !important;   
  }

   #resultTable table {
      border: 0;
    }

   #resultTable table thead {
      display: none;
    }

   #resultTable table tr {
      margin-top: 10px;
      margin-bottom: 20px;
      display: block;
      border: 3px solid;
      border-color:#F2F4F6 !important;      
      background-color: white !important;
    }

   #resultTable table td {
      display: block;
      border: none !important;
      font-size: 12px;
      text-align: right;
      padding: 4px 10px 4px 10px;
    }

   #resultTable table td:last-child {
      border-bottom: 0;
    }

    #resultTable table td div::before{
      content: attr(id);
      float: left;
      text-transform: uppercase;
      font-weight: bold;
    }
    	#resultTable	tbody{
			line-height:0!important;
		}

    .table-btn {
    float: none !important;
    background: none !important;
    }
}

.calendar-search{
 width: 13%;
}

.input-group .form-control, .input-group-addon, .input-group-btn{
    font-size: 13px;
}

.form-interspace{
  margin-left: -1%;
}

.icon-PE::before{
  content: url('/static/img/icons/ic_doc_pedido.png');
}

.icon-DV::before{
  content: url('/static/img/icons/ic_doc_devolucion.png');
}

.icon-OC::before{
  content: url('/static/img/icons/ic_doc_oc.png');
}
 
.icon-GU::before{
  content: url('/static/img/icons/ic_doc_devolucion.png');
} 

.icon-BL::before{
  content: url('/static/img/icons/ic_doc_guia_carga.png');
}

.form-interspace-xl{
  margin-left: -1%;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media screen and (max-width: 1150px) {
  .form-interspace{
    margin-left: 0%;
  }
  .form-interspace-xl{
    margin-left: 0%;
  }
}

@media screen and (min-width: 1720px) {
  .form-interspace-xl{
    margin-left: -2%;
  }
}

@media screen and (min-width: 1900px) {
  .form-interspace-xl{
    margin-left: -3%;
  }
}

@media screen and (max-width: 1220px) {
  .input-group .form-control, .input-group-addon, .input-group-btn{
    font-size: 11px;
  }
}

@media screen and (max-width: 1150px) {  
  .calendar-search{
    width: 100%;
  }
  
  .input-group .form-control, .input-group-addon, .input-group-btn{
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// DocumentSearch.vue?4f40c122